<button mat-menu-item class="interactive-dropdown-item" (click)="clicked.emit()">
  <span class="interactive-dropdown-item__content">
    <span class="interactive-dropdown-item__content-icon">
      @if (selected) {
        <fa-icon [icon]="faCheck"></fa-icon>
      }
    </span>
    <span class="interactive-dropdown-item__content-text">
      <ng-content select="[slot=text]"></ng-content>
    </span>
  </span>
</button>
